import { GivelifyLabel } from '@givelify/givelify-ui';
import { Link, styled } from '@mui/material';

const borderStyle = (theme: any) => `1px solid ${theme.legacy.colors.grey200}`;

export const Wrapper = styled('div')(({ theme }) => ({
    borderTop: borderStyle(theme),
    paddingTop: 24,
    marginBottom: 24,
}));

export const BorderTop = styled('div')(({ theme }) => ({
    borderTop: borderStyle(theme),
}));

export const HeaderRowWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 16,
});

export const FirstRowWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'row',
});

export const SecondRowWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 48,
    marginTop: 8,
});

export const MessengerContainer = styled('div')({
    flex: 1,
    marginTop: 48,
    marginBottom: 48,
});

export const OpenDetail = styled('div')(({ theme }) => ({
    '& svg': {
        marginLeft: theme.spacing(1),
    },
}));

export const BtnDetail = styled(Link)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    textDecoration: 'none',
});

export const Column1Label = styled(GivelifyLabel)({
    flex: 1,
    textAlign: 'right',
});

export const Column1Div = styled('div')({
    flex: 1,
    textAlign: 'right',
});

export const Column2Label = styled(GivelifyLabel)({
    flex: 2,
});

export const Column2Div = styled('div')({
    flex: 2,
});

export const Column5Label = styled(GivelifyLabel)({
    flex: 5,
});

export const Column5Div = styled('div')({
    flex: 5,
});

export const DonationDetailsWrapper = styled('div')({
    marginTop: 32,
    marginBottom: 32,
});
